import type { PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import { createQueryContextCacheConfig } from '../../common/utils/query-context-headers';

import parameters from './__generated__/AsyncTeamSelectorQuery.graphql';

type EntryPointParams = { containerId: string; cloudId?: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

export const asyncTeamSelectorEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/teams/team-selector" */ './AsyncTeamSelector'
			).then(({ AsyncTeamSelectorWithQuery }) => AsyncTeamSelectorWithQuery),
		{
			moduleId: 'team-selector-entrypoint',
		},
	),
	getPreloadProps: ({ containerId, cloudId }: EntryPointParams) => {
		const networkCacheConfig = createQueryContextCacheConfig(cloudId);
		return {
			queries: {
				getTeamsForContainerQuery: {
					parameters,
					variables: {
						containerId,
					},
					options: {
						fetchPolicy,
						...(networkCacheConfig && { networkCacheConfig }),
					},
				},
			},
			extraProps: { containerId },
		};
	},
});
